import React from 'react';

import { RadioButton } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { AddressContainer, RadioButtonContainer } from './styled';
import { IDeliveryAddressItemProps } from './types';

const DeliveryAddressItem: React.FC<IDeliveryAddressItemProps> = ({
  address,
  selected,
  onSelect,
}) => {
  const { formatMessage } = useIntl();

  const deliveryHeader = (
    <div data-private>
      {address.addressLine1}
      <div>
        {address.addressLine2 &&
          formatMessage({ id: 'unitNumber' }, { unitNumber: address.addressLine2 })}
      </div>
    </div>
  );

  const deliveryLabel = (
    <div data-private>
      {address.city}, {address.state} {address.zip}
      <br />
      {address.phoneNumber}
    </div>
  );

  return (
    <>
      <AddressContainer data-testid="delivery-address-item">
        <RadioButtonContainer>
          <RadioButton
            checked={selected}
            onChange={onSelect}
            labelHeader={deliveryHeader}
            label={deliveryLabel}
          />
        </RadioButtonContainer>
      </AddressContainer>
    </>
  );
};

export default DeliveryAddressItem;
